// This is the runtime configuration file.  It complements the Gruntfile.js by
// supplementing shared properties.
require.config({
  paths: {
    vendor: "../vendor",
    almond: "../vendor/node_modules/almond/almond",
    requirejs: "../vendor/node_modules/requirejs/require",
    underscore: "../vendor/node_modules/lodash/dist/lodash.underscore",
    lodash: "../vendor/node_modules/lodash/dist/lodash",
    ldsh: "../vendor/node_modules/lodash-template-loader/loader",
    jquery: "../vendor/node_modules/jquery/dist/jquery",
    backbone: "../vendor/node_modules/backbone/backbone",
    bootstrap: "../vendor/node_modules/bootstrap/dist/js/bootstrap",
    bootstrapValidator:
      "../vendor/node_modules/bootstrapValidator/dist/js/bootstrapValidator",
    layoutmanager:
      "../vendor/node_modules/backbone.layoutmanager/backbone.layoutmanager",
    i18n: "../vendor/node_modules/i18next-client/i18next.amd.withJQuery",
    select2: "../vendor/node_modules/Select2/select2",
    select2Locales: "../vendor/node_modules/select2/select2_locales",
    env: "environments/index",
    tagmanager: "../vendor/node_modules/jquery-tagmanager/tagmanager",
    sinon: "../vendor/node_modules/sinon/pkg/sinon",
    accounting: "../vendor/node_modules/accounting/accounting",
    d3: "../vendor/node_modules/d3/d3.min",
    d3pie: "../vendor/node_modules/d3pie/d3pie/d3pie.min",
    venn: "../vendor/node_modules/venn.js/venn",
    raven: "../vendor/node_modules/raven-js/dist/raven",
    ravenNative: "../vendor/node_modules/raven-js/plugins/native",
    ravenJQuery: "../vendor/node_modules/raven-js/plugins/jquery",
    mdnotice: "../vendor/node_modules/md-noticejs/lib/mdnotice",
    mdzendeskjs: "../vendor/node_modules/md-zendeskjs/dist/index.umd",
    "highcharts-module": "../vendor/node_modules/highcharts-release/highcharts",
    react: "../vendor/node_modules/react/umd/react.production.min",
    "react-dom":
      "../vendor/node_modules/react-dom/umd/react-dom.production.min",
    "prop-types": "../vendor/node_modules/prop-types/prop-types.min",
    mdheaderjs: "../vendor/node_modules/md-headerjs/dist/index.umd",
    mdfooterjs: "../vendor/node_modules/md-footerjs/dist/index.umd",
    mdsidebarjs: "../vendor/node_modules/md-sidebarjs/dist/index.umd",
    mdremindersjs: "../vendor/node_modules/md-remindersjs/dist/index.umd",
    ServicesHelper: "./helpers/ServicesHelper",
    ProductsHelper: "./helpers/ProductsHelper",
    ThemesHelper: "./helpers/ThemesHelper",
    stripe: "https://js.stripe.com/v3/?noext",
  },

  config: {
    env: {
      env: "development",
    },
  },

  shim: {
    ThemesHelper: {
      exports: "ThemesHelper",
    },
    RemindersHelper: {
      exports: "RemindersHelper",
      deps: ["jquery", "i18n"],
    },
    backbone: {
      deps: ["jquery", "underscore"],
      exports: "Backbone",
    },
    bootstrap: ["jquery"],
    bootstrapValidator: ["bootstrap"],
    tagmanager: {
      deps: ["jquery"],
    },
    select2: {
      deps: ["jquery"],
    },
    select2Locales: {
      deps: ["select2"],
    },
    sinon: {
      exports: "sinon",
    },
    d3pie: {
      deps: ["d3"],
    },
    ravenNative: {
      deps: ["raven"],
    },
    ravenJQuery: {
      deps: ["raven"],
    },
    mdnotice: {
      deps: ["backbone"],
    },
    stripe: {
      exports: "Stripe",
    },
  },
});

define("config", function(){});

